import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiV2ReservationusernoteElFindDateParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiV2ReservationusernoteElFindDateParams, unknown>

const fetchReservationUserNotesByDate = async (params: ApiV2ReservationusernoteElFindDateParams) => {
  const { data } = await apiClient.v2.apiV2ReservationusernoteElFindDate(params);
  return checkApiResponse(data);
}

export const v2ReservationUserNoteDateKeys = {
  all: [QUERY_KEY.v2apiV2ReservationusernoteElFindDate] as const,
  list: (params: ApiV2ReservationusernoteElFindDateParams) => [...v2ReservationUserNoteDateKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(v2ReservationUserNoteFindDateQueryOptions(params))` */
export const v2ReservationUserNoteFindDateQueryOptions = (params: ApiV2ReservationusernoteElFindDateParams) => ({
  queryKey: v2ReservationUserNoteDateKeys.list(params),
  queryFn: () => fetchReservationUserNotesByDate(params),
})

export const useV2ReservationUserNoteFindDateQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: v2ReservationUserNoteDateKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchReservationUserNotesByDate(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
